import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import Dashboard from "@/pages/Dashboard";
import ProjectWizard from "@/pages/ProjectWizard";
import AuthPage from "@/pages/AuthPage";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Company from "@/pages/Company";
import { ForgotPassword, ResetPassword, AcceptInvite } from "@/pages/AuthFlows";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/accesso" element={<AuthPage />} />
          <Route path="/password-dimenticata" element={<ForgotPassword />} />
          <Route path="/reimposta-password" element={<ResetPassword />} />
          <Route path="/invito" element={<AcceptInvite />} />
          <Route path="/azienda" element={<ProtectedRoute><Company /></ProtectedRoute>} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/progetti/:id" element={<ProtectedRoute><ProjectWizard /></ProtectedRoute>} />
          <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
        </Routes>
      </AuthProvider>
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}
